import React, { useState, createContext, useEffect } from 'react'
import styled from '@emotion/styled'
import { Header } from "./components/Header"
import { useContentful } from "./hooks/useContentful"
import { ModelContent, ModelTitle, Specs, SpecsContainer, SpecsItem, Gallery, GalleryContainer, NoModelSelected } from "./styles/modelContent"
import ContactForm from './components/ContactForm'
import CustomSlider from './components/CustomSlider'
import Img from './components/Img'
import HeroSlider from './components/HeroSlider'
import WhatsappFloatingButton from './components/WhatsappFloatingButton'

export const AppContext = createContext(undefined);

export default function App() {
  const { 
    desktopSliderImagesUrls,
    boatsData: { boats, selectedModel, selectedBrand, selectedModelName, selectedModelNumberOfImages, numberOfLoadedImages }, 
    actions: { setSelectedBrand, setSelectedModelName, setNumberOfLoadedImages} 
  } = useContentful();
  
  const [modelIsLoading, setModelIsLoading] = useState(true)

  const mql = window.matchMedia('(max-width: 800px)');
  let isMobile = mql.matches;

  useEffect(() => {
    if (selectedModelNumberOfImages === numberOfLoadedImages) {
      setModelIsLoading(false)
    }
  }, [selectedModelNumberOfImages, numberOfLoadedImages])

  useEffect(() => {
    if (!selectedModelName) return
    setModelIsLoading(true)
  }, [selectedModelName])
  
  useEffect(() => {
    setTimeout(() => {
      setModelIsLoading(false)
    }, 3000);
  }, [selectedModelName])
  

  return (
    <AppContext.Provider value={[modelIsLoading, setModelIsLoading]}>
      <PageContainer>
        <WhatsappFloatingButton />
        <Header isMobile={isMobile} />
        <BannerContainer>
          {!isMobile && desktopSliderImagesUrls && (
            // <Banner src={"img/banner.jpg"}/>
            <HeroSlider items={desktopSliderImagesUrls} />
            ) || (
            <Banner src={"img/banner-mobile.jpg"}/>
          )}
        </BannerContainer>
        <a name="marcas"/>
        <BrandSelector>
          <div className='buttonContainer'>
            <BrandButton isSelected={selectedBrand === "bermuda"} role="button" onClick={() => setSelectedBrand("bermuda")}>
              <img style={{width: "92%"}} src="img/brands/logo_bermuda.png" />
            </BrandButton>
          </div>
          <div className='buttonContainer'>
            <BrandButton isSelected={selectedBrand.toLowerCase() === "klase"} role="button" onClick={() => setSelectedBrand("klase")}>
              <img style={{width: "66%"}} src="img/brands/logo_klase.png" />
            </BrandButton>
          </div>
          <div className='buttonContainer'>
            <BrandButton isSelected={selectedBrand === "piccini"} role="button" onClick={() => setSelectedBrand("piccini")}>
              <img style={{width: "92%"}} src="img/brands/logo_piccini.png" />
            </BrandButton>
          </div>
          <div className='buttonContainer'>
            <BrandButton isSelected={selectedBrand === "drakkar"} role="button" onClick={() => setSelectedBrand("drakkar")}>
              <img style={{width: "92%"}} src="img/brands/logo_drakkar.png" />
            </BrandButton>
          </div>
        </BrandSelector>
        <BrandHelmet>
          <div>
            <img src={`img/brands/logo_${selectedBrand}.png`} alt="" />
          </div>
          <nav>
            <ul>
              {
                !boats ? (<></>) : boats
                  .filter(boat => boat.fields.marca.toLowerCase() === selectedBrand.toLowerCase())
                  .sort((a, b) => a.fields.posicion - b.fields.posicion)
                  .map((boat, key) => 
                    <BrandNavItem 
                      key={key} 
                      role="button" 
                      isSelected={selectedModelName === boat.fields.modelo}
                      onClick={() => setSelectedModelName(boat.fields.modelo)}
                    >
                      {boat.fields.modelo}
                    </BrandNavItem>
                )
              }
            </ul>
          </nav>
        </BrandHelmet>
        {
          !selectedModel ? 
          (
            <NoModelSelected>
              <p>Seleccione un modelo para visualizar</p>
            </NoModelSelected>
          ) : (
            <ModelContent>
              <LoadingScreen isVisible={modelIsLoading}>
                <Spinner>
                  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="-2 -2 42 42" stroke="#0e2854">
                      <g fill="none" fillRule="evenodd">
                          <g transform="translate(1 1)" strokeWidth="6">
                              <circle strokeOpacity=".5" cx="18" cy="18" r="18"/>
                              <path d="M36 18c0-9.94-8.06-18-18-18">
                                  <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/>
                              </path>
                          </g>
                      </g>
                  </svg>
                </Spinner>
              </LoadingScreen>
              <ModelTitle> 
                {selectedModel.fields.descripcion ? (
                  <>
                    <h5>{selectedModel.fields.modelo}.</h5>
                    <p>{selectedModel.fields.descripcion}</p>
                  </>
                ) : (
                  <h3>{selectedModel.fields.modelo}.</h3>
                )}
                
              </ModelTitle>
              {
                isMobile ? (
                  <CustomSlider items={[selectedModel.fields.foto1, selectedModel.fields.foto2, ...selectedModel.fields.galeria]}/>
                ) : (<></>)
              }
              {
                !isMobile && selectedModel.fields.foto1 ? (
                  <Img 
                    key={selectedModel.fields.foto1.sys.id} 
                    onImageLoad={() => {
                      setNumberOfLoadedImages(n => n + 1)
                    }} 
                    src={selectedModel.fields.foto1.fields.file.url} 
                    alt="" 
                  />
                ) : (<></>)
              }
              {
                !isMobile && selectedModel.fields.foto2 ? (
                  <Img 
                    key={selectedModel.fields.foto2.sys.id} 
                    onImageLoad={() => {
                      setNumberOfLoadedImages(n => n + 1)
                    }} 
                    src={selectedModel.fields.foto2.fields.file.url} 
                    alt="" 
                  />
                  ) : (<></>)
              }
              <SpecsContainer>
                <h4>Especificaciones</h4>
              <Specs>
                {
                  selectedModel.fields.eslora ? (
                    <SpecsItem>
                      <img src="img/specs/eslora.png" alt="eslora" />
                      <div>
                        <h5>{selectedModel.fields.eslora}</h5>
                        <p>Eslora</p>
                      </div>
                    </SpecsItem>
                  ) : (<></>)
                }
                {
                  selectedModel.fields.eslora ? (
                    <SpecsItem>
                      <img src="img/specs/manga.png" alt="manga" />
                      <div>
                        <h5>{selectedModel.fields.manga}</h5>
                        <p>Manga</p>
                      </div>
                    </SpecsItem>
                  ) : (<></>)
                }
            
                {
                  selectedModel.fields.puntal ? (
                    <SpecsItem>
                      <img src="img/specs/puntal.png" alt="puntal" />
                      <div>
                        <h5>{selectedModel.fields.puntal}</h5>
                        <p>Puntal</p>
                      </div>
                    </SpecsItem>
                  ) : (<></>)
                }
                {
                  selectedModel.fields.calado ? (
                    <SpecsItem>
                      <img src="img/specs/calado.png" alt="calado" />
                      <div>
                        <h5>{selectedModel.fields.calado}</h5>
                        <p>calado</p>
                      </div>
                    </SpecsItem>
                  ) : (<></>)
                }
                {
                  selectedModel.fields.potenciaDelMotor ? (
                    <SpecsItem>
                      <img src="img/specs/potenciaDelMotor.png" alt="potencia Del Motor" />
                      <div>
                        <h5>{selectedModel.fields.potenciaDelMotor}</h5>
                        <p>Potencia Admisible</p>
                      </div>
                    </SpecsItem>
                  ) : (<></>)
                }
                {
                  selectedModel.fields.capacidadMaxima ? (
                    <SpecsItem>
                      <img src="img/specs/capacidadMaxima.png" alt="capacidad Maxima" />
                      <div>
                        <h5>{selectedModel.fields.capacidadMaxima}</h5>
                        <p>Capacidad Máxima</p>
                      </div>
                    </SpecsItem>
                  ) : (<></>)
                }
                {
                  selectedModel.fields.fichaTecnica ? (
                    <SpecsItem>
                      <a href={selectedModel.fields.fichaTecnica.fields.file.url} target='_blank'>
                        Ficha tecnica
                      </a>
                    </SpecsItem>
                  ) : (<></>)
                }
              </Specs>
              </SpecsContainer>
              {!isMobile && (
                <GalleryContainer>
                  <h5>Galería</h5>
                  <Gallery>
                    {selectedModel.fields.galeria && selectedModel.fields.galeria.map((foto, index) => 
                      <Img 
                      key={foto.sys.id} 
                      onImageLoad={() => {
                        setNumberOfLoadedImages(n => n + 1)
                      }} 
                      src={foto.fields.file.url} 
                      alt="" 
                      />
                    )}
                  </Gallery>
                </GalleryContainer>
              )}
            </ModelContent>
          )
        }
        <a name="nosotros"/>
        <AboutUs>
          <h3>Sport Nautica.</h3>
          <p>
            Es el principio de los desafíos que más te gusta conquistar. Donde la pureza de los detalles del diseño
            conviven con la potencia, la tecnología y la mecánica. Una combinación que encanta a lo urbano y domina
            cualquier tipo de terreno. Es el concesionario donde encontrás las marcas líderes que acompañan tu pasión.
          </p>
        </AboutUs>
        <a name="contacto"/>
        <ContactForm />
        <Footer>
          <img src="img/logo.png" alt="" />
          <ContactInfoContainer>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50">
                <path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.228516 L 14.615234 26.230469 C 14.588494 26.195329 14.973031 26.752191 15.486328 27.419922 C 15.999626 28.087653 16.717405 28.96464 17.619141 29.914062 C 19.422612 31.812909 21.958282 34.007419 25.105469 35.349609 C 26.554789 35.966779 27.698179 36.339417 28.564453 36.611328 C 30.169845 37.115426 31.632073 37.038799 32.730469 36.876953 C 33.55263 36.755876 34.456878 36.361114 35.351562 35.794922 C 36.246248 35.22873 37.12309 34.524722 37.509766 33.455078 C 37.786772 32.688244 37.927591 31.979598 37.978516 31.396484 C 38.003976 31.104927 38.007211 30.847602 37.988281 30.609375 C 37.969311 30.371148 37.989581 30.188664 37.767578 29.824219 C 37.302009 29.059804 36.774753 29.039853 36.224609 28.767578 C 35.918939 28.616297 35.048661 28.191329 34.175781 27.775391 C 33.303883 27.35992 32.54892 26.991953 32.083984 26.826172 C 31.790239 26.720488 31.431556 26.568352 30.914062 26.626953 C 30.396569 26.685553 29.88546 27.058933 29.587891 27.5 C 29.305837 27.918069 28.170387 29.258349 27.824219 29.652344 C 27.819619 29.649544 27.849659 29.663383 27.712891 29.595703 C 27.284761 29.383815 26.761157 29.203652 25.986328 28.794922 C 25.2115 28.386192 24.242255 27.782635 23.181641 26.847656 L 23.181641 26.845703 C 21.603029 25.455949 20.497272 23.711106 20.148438 23.125 C 20.171937 23.09704 20.145643 23.130901 20.195312 23.082031 L 20.197266 23.080078 C 20.553781 22.728924 20.869739 22.309521 21.136719 22.001953 C 21.515257 21.565866 21.68231 21.181437 21.863281 20.822266 C 22.223954 20.10644 22.02313 19.318742 21.814453 18.904297 L 21.814453 18.902344 C 21.828863 18.931014 21.701572 18.650157 21.564453 18.326172 C 21.426943 18.001263 21.251663 17.580039 21.064453 17.130859 C 20.690033 16.232501 20.272027 15.224912 20.023438 14.634766 L 20.023438 14.632812 C 19.730591 13.937684 19.334395 13.436908 18.816406 13.195312 C 18.298417 12.953717 17.840778 13.022402 17.822266 13.021484 L 17.820312 13.021484 C 17.450668 13.004432 17.045038 13 16.642578 13 z M 16.642578 15 C 17.028118 15 17.408214 15.004701 17.726562 15.019531 C 18.054056 15.035851 18.033687 15.037192 17.970703 15.007812 C 17.906713 14.977972 17.993533 14.968282 18.179688 15.410156 C 18.423098 15.98801 18.84317 16.999249 19.21875 17.900391 C 19.40654 18.350961 19.582292 18.773816 19.722656 19.105469 C 19.863021 19.437122 19.939077 19.622295 20.027344 19.798828 L 20.027344 19.800781 L 20.029297 19.802734 C 20.115837 19.973483 20.108185 19.864164 20.078125 19.923828 C 19.867096 20.342656 19.838461 20.445493 19.625 20.691406 C 19.29998 21.065838 18.968453 21.483404 18.792969 21.65625 C 18.639439 21.80707 18.36242 22.042032 18.189453 22.501953 C 18.016221 22.962578 18.097073 23.59457 18.375 24.066406 C 18.745032 24.6946 19.964406 26.679307 21.859375 28.347656 C 23.05276 29.399678 24.164563 30.095933 25.052734 30.564453 C 25.940906 31.032973 26.664301 31.306607 26.826172 31.386719 C 27.210549 31.576953 27.630655 31.72467 28.119141 31.666016 C 28.607627 31.607366 29.02878 31.310979 29.296875 31.007812 L 29.298828 31.005859 C 29.655629 30.601347 30.715848 29.390728 31.224609 28.644531 C 31.246169 28.652131 31.239109 28.646231 31.408203 28.707031 L 31.408203 28.708984 L 31.410156 28.708984 C 31.487356 28.736474 32.454286 29.169267 33.316406 29.580078 C 34.178526 29.990889 35.053561 30.417875 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.995572 30.982516 35.998992 31.07786 35.986328 31.222656 C 35.951258 31.624292 35.8439 32.180225 35.628906 32.775391 C 35.523582 33.066746 34.975018 33.667661 34.283203 34.105469 C 33.591388 34.543277 32.749338 34.852514 32.4375 34.898438 C 31.499896 35.036591 30.386672 35.087027 29.164062 34.703125 C 28.316336 34.437036 27.259305 34.092596 25.890625 33.509766 C 23.114812 32.325956 20.755591 30.311513 19.070312 28.537109 C 18.227674 27.649908 17.552562 26.824019 17.072266 26.199219 C 16.592866 25.575584 16.383528 25.251054 16.208984 25.021484 L 16.207031 25.019531 C 15.897202 24.609805 14 21.970851 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"/>
              </svg>
              <p>3412124055</p>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50">
                <path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.228516 L 14.615234 26.230469 C 14.588494 26.195329 14.973031 26.752191 15.486328 27.419922 C 15.999626 28.087653 16.717405 28.96464 17.619141 29.914062 C 19.422612 31.812909 21.958282 34.007419 25.105469 35.349609 C 26.554789 35.966779 27.698179 36.339417 28.564453 36.611328 C 30.169845 37.115426 31.632073 37.038799 32.730469 36.876953 C 33.55263 36.755876 34.456878 36.361114 35.351562 35.794922 C 36.246248 35.22873 37.12309 34.524722 37.509766 33.455078 C 37.786772 32.688244 37.927591 31.979598 37.978516 31.396484 C 38.003976 31.104927 38.007211 30.847602 37.988281 30.609375 C 37.969311 30.371148 37.989581 30.188664 37.767578 29.824219 C 37.302009 29.059804 36.774753 29.039853 36.224609 28.767578 C 35.918939 28.616297 35.048661 28.191329 34.175781 27.775391 C 33.303883 27.35992 32.54892 26.991953 32.083984 26.826172 C 31.790239 26.720488 31.431556 26.568352 30.914062 26.626953 C 30.396569 26.685553 29.88546 27.058933 29.587891 27.5 C 29.305837 27.918069 28.170387 29.258349 27.824219 29.652344 C 27.819619 29.649544 27.849659 29.663383 27.712891 29.595703 C 27.284761 29.383815 26.761157 29.203652 25.986328 28.794922 C 25.2115 28.386192 24.242255 27.782635 23.181641 26.847656 L 23.181641 26.845703 C 21.603029 25.455949 20.497272 23.711106 20.148438 23.125 C 20.171937 23.09704 20.145643 23.130901 20.195312 23.082031 L 20.197266 23.080078 C 20.553781 22.728924 20.869739 22.309521 21.136719 22.001953 C 21.515257 21.565866 21.68231 21.181437 21.863281 20.822266 C 22.223954 20.10644 22.02313 19.318742 21.814453 18.904297 L 21.814453 18.902344 C 21.828863 18.931014 21.701572 18.650157 21.564453 18.326172 C 21.426943 18.001263 21.251663 17.580039 21.064453 17.130859 C 20.690033 16.232501 20.272027 15.224912 20.023438 14.634766 L 20.023438 14.632812 C 19.730591 13.937684 19.334395 13.436908 18.816406 13.195312 C 18.298417 12.953717 17.840778 13.022402 17.822266 13.021484 L 17.820312 13.021484 C 17.450668 13.004432 17.045038 13 16.642578 13 z M 16.642578 15 C 17.028118 15 17.408214 15.004701 17.726562 15.019531 C 18.054056 15.035851 18.033687 15.037192 17.970703 15.007812 C 17.906713 14.977972 17.993533 14.968282 18.179688 15.410156 C 18.423098 15.98801 18.84317 16.999249 19.21875 17.900391 C 19.40654 18.350961 19.582292 18.773816 19.722656 19.105469 C 19.863021 19.437122 19.939077 19.622295 20.027344 19.798828 L 20.027344 19.800781 L 20.029297 19.802734 C 20.115837 19.973483 20.108185 19.864164 20.078125 19.923828 C 19.867096 20.342656 19.838461 20.445493 19.625 20.691406 C 19.29998 21.065838 18.968453 21.483404 18.792969 21.65625 C 18.639439 21.80707 18.36242 22.042032 18.189453 22.501953 C 18.016221 22.962578 18.097073 23.59457 18.375 24.066406 C 18.745032 24.6946 19.964406 26.679307 21.859375 28.347656 C 23.05276 29.399678 24.164563 30.095933 25.052734 30.564453 C 25.940906 31.032973 26.664301 31.306607 26.826172 31.386719 C 27.210549 31.576953 27.630655 31.72467 28.119141 31.666016 C 28.607627 31.607366 29.02878 31.310979 29.296875 31.007812 L 29.298828 31.005859 C 29.655629 30.601347 30.715848 29.390728 31.224609 28.644531 C 31.246169 28.652131 31.239109 28.646231 31.408203 28.707031 L 31.408203 28.708984 L 31.410156 28.708984 C 31.487356 28.736474 32.454286 29.169267 33.316406 29.580078 C 34.178526 29.990889 35.053561 30.417875 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.995572 30.982516 35.998992 31.07786 35.986328 31.222656 C 35.951258 31.624292 35.8439 32.180225 35.628906 32.775391 C 35.523582 33.066746 34.975018 33.667661 34.283203 34.105469 C 33.591388 34.543277 32.749338 34.852514 32.4375 34.898438 C 31.499896 35.036591 30.386672 35.087027 29.164062 34.703125 C 28.316336 34.437036 27.259305 34.092596 25.890625 33.509766 C 23.114812 32.325956 20.755591 30.311513 19.070312 28.537109 C 18.227674 27.649908 17.552562 26.824019 17.072266 26.199219 C 16.592866 25.575584 16.383528 25.251054 16.208984 25.021484 L 16.207031 25.019531 C 15.897202 24.609805 14 21.970851 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"/>
              </svg>
              <p>3416809874</p>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="10 0 80 100" >
                <g>
                  <path d="M 45 90 c -0.354 0 -0.681 -0.187 -0.861 -0.491 l -4.712 -7.972 C 30.222 65.976 20.704 49.884 17.64 43.734 c -2.033 -4.169 -3.062 -8.646 -3.062 -13.313 C 14.578 13.647 28.225 0 45 0 c 16.774 0 30.422 13.647 30.422 30.422 c 0 4.664 -1.028 9.141 -3.056 13.305 c -0.012 0.023 -0.023 0.045 -0.036 0.067 c -3.095 6.193 -12.581 22.231 -21.757 37.743 l -4.712 7.972 C 45.681 89.813 45.354 90 45 90 z M 45 2 C 29.328 2 16.578 14.75 16.578 30.422 c 0 4.359 0.96 8.542 2.854 12.43 c 3.027 6.073 12.522 22.126 21.705 37.649 L 45 87.035 l 3.853 -6.517 c 9.187 -15.531 18.686 -31.591 21.717 -37.676 c 0.009 -0.017 0.018 -0.033 0.026 -0.049 c 1.875 -3.874 2.826 -8.036 2.826 -12.372 C 73.422 14.75 60.672 2 45 2 z"  transform=" matrix(1 0 0 1 0 0) " />
                  <path d="M 45 42.436 c -7.279 0 -13.2 -5.922 -13.2 -13.201 s 5.921 -13.2 13.2 -13.2 c 7.278 0 13.2 5.921 13.2 13.2 S 52.278 42.436 45 42.436 z M 45 18.035 c -6.176 0 -11.2 5.024 -11.2 11.2 c 0 6.176 5.024 11.201 11.2 11.201 s 11.2 -5.024 11.2 -11.201 C 56.2 23.059 51.176 18.035 45 18.035 z"  transform=" matrix(1 0 0 1 0 0)" />
                </g>
              </svg>
              <p>Av. Eva Perón 5858, S2000 Rosario, Santa Fe</p>
            </div>
          </ContactInfoContainer>
        </Footer>
      </PageContainer>
    </AppContext.Provider>
  )
}

const LoadingScreen = styled.div`
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  @keyframes fadeout {
    0%   { }
    99%  { opacity: 0; }
    100% { opacity: 0; visibility: hidden; }
  }

  animation: ${props => props.isVisible ? "" : "fadeout 200ms forwards"}; 
`

const PageContainer = styled.div`
  position: relative;
  max-width: 960px;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const Banner = styled.img`
  width: 100%;
`

const BannerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const BrandSelector = styled.div`
  background: url("./img/brands_background.png");
  width: 100%;
  height: 300px;
  margin-top: 26px;
  padding: 0 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  button{
    background-color: transparent;
    border: none;
  }
  .buttonContainer {
    flex-basis: 25%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  @media only screen and (max-width: 800px) {
    padding: 0 20px;
    .buttonContainer {
      flex-basis: 50%;
  }
  }
`

const Spinner = styled.div`
  svg {
    fill: black;
  }
`

const BrandButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: ${props => props.isSelected? "gray" : "#0e2854"};
  border: ${props => props.isSelected? "1px solid white" : "1px solid transparent"};
  img {
    -webkit-user-drag: none;
    max-height: 120px;
    max-width: 126px;
    width: auto;
    height: auto;
  }
  @media only screen and (max-width: 800px) {
    width: 110px;
    height: 110px;
  }
`

const BrandHelmet = styled.div`
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  div{
    height: 144px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-height: 90px;
      max-width: 300px;
      width: auto;
      height: auto;
      filter: brightness(0);
    }
  }
  nav {
    width: 100%;
    background-color: gray;
    ul{
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      list-style: none;
      padding: 0 60px;
    }
    @media only screen and (max-width: 800px) {
      ul{
        gap: 4px;
        padding: 6px 10px;
      }
    }
  }
`

const BrandNavItem = styled.li`
  cursor: pointer;
  color: white;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 12px 10px;
  display: flex;
  align-items: center;
  background-color: ${props => props.isSelected? "#0e2854" : "transparent"};
  @media only screen and (max-width: 800px) {
    padding: 8px 6px;
    font-size: 11px;
    text-align: center;
    border: solid 1px rgba(0, 0, 0, 0.4);
  }
`

export const AboutUs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #1f3566;
  color: white;
  padding: 44px;
  h3 {
    font-size: 50px;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 18px;
  }
  P {
    font-size: 19px;
    max-width: 73ch;
    text-align: center;
    font-weight: 200;
  }
  @media only screen and (max-width: 800px) {
    padding: 30px;
    h3 {
      font-size: 30px;
      text-align: center;
    }
  }
`

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  background-color: #1a1a1a;
  padding: 50px 80px;
  img {
    filter: brightness(100);
    margin-right: 70px;
  }
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 40px 30px;
    img {
      width: 150px;
      margin-bottom: 30px;
    }
  }
`

export const ContactInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: #dfdfdf;
  text-transform: uppercase;
  row-gap: 8px;
  div{
    display: flex;
  }
  svg {
    fill: #dfdfdf;
    width: 24px;
    margin-right: 5px;
  }

`